import React from "react";
import "./TopFailCriteria.css";

function TopFailCriteria({ criterias = [] }) {
    if (!criterias || criterias.length === 0) return null;

    const nbFails = criterias.filter(c => c.final_result === "fail" && c.detection > 0).length;

    const borderColor = "#ff403d";   // rouge/orange
    const textColor = "#ff6b3d";
    const backgroundColor = "#ffdedd"; // orange tres clair

    return (
        <div className="top-fail-criteria">
            {nbFails > 0 && (
                <span className="top-fail-criteria_item top-fail-criteria_more"
                    style={{ borderColor: borderColor, color: textColor, background: backgroundColor }}>
                    {nbFails} Fail{nbFails > 1 && "s"}
                </span>
            )}
        </div>
    );
}

export default TopFailCriteria;